export const FETCH_MERCHANT_BEGIN = "FETCH_MERCHANT_BEGIN";
export const FETCH_MERCHANT_SUCCESS = "FETCH_MERCHANT_SUCCESS";
export const FETCH_MERCHANT_FAILURE = "FETCH_MERCHANT_FAILURE";

export const FETCH_MERCHANT_CURRENCY = "FETCH_MERCHANT_CURRENCY";

export const FETCH_CUSTOMER_BEGIN = "FETCH_CUSTOMER_BEGIN";
export const FETCH_CUSTOMER_SUCCESS = "FETCH_CUSTOMER_SUCCESS";
export const FETCH_CUSTOMER_FAILURE = "FETCH_CUSTOMER_FAILURE";

export const FETCH_CUSTOMERGIFTCARD_BEGIN = "FETCH_CUSTOMERGIFTCARD_BEGIN";
export const FETCH_CUSTOMERGIFTCARD_SUCCESS = "FETCH_CUSTOMERGIFTCARD_SUCCESS";
export const FETCH_CUSTOMERGIFTCARD_FAILURE = "FETCH_CUSTOMERGIFTCARD_FAILURE";

export const UPDATE_CUSTOMER_BIRTHDAY = "FETCH_CUSTOMER_BIRTHDAY";

export const CURRENT_DISCOUNTCODE = "CURRENT_DISCOUNTCODE";
export const CURRENT_GIFTCARD = "CURRENT_GIFTCARD";

export const CURRENT_CHARITY_DONATE = "CURRENT_CHARITY_DONATE";

export const GET_ACTIVE_PAGE = "GET_ACTIVE_PAGE";
export const SET_CUSTOMERID = "SET_CUSTOMERID";
export const SET_SHOPDOMAIN = "SET_SHOPDOMAIN";
export const SET_PARENTLOCATION = "SET_PARENTLOCATION";

export const FETCH_VIPTIERS_BEGIN = "FETCH_VIPTIERS_BEGIN";
export const FETCH_VIPTIERS_SUCCESS = "FETCH_VIPTIERS_SUCCESS";
export const FETCH_VIPTIERS_FAILURE = "FETCH_VIPTIERS_FAILURE";

export const FETCH_MEMBERSSHIPPROGRAM_BEGIN = "FETCH_MEMBERSSHIPPROGRAM_BEGIN";
export const FETCH_MEMBERSSHIPPROGRAM_SUCCESS = "FETCH_MEMBERSSHIPPROGRAM_SUCCESS";
export const FETCH_MEMBERSSHIPPROGRAM_FAILURE = "FETCH_MEMBERSSHIPPROGRAM_FAILURE";

export const FETCH_LIMITEDTIMEOFFERPROGRAM_BEGIN = "FETCH_LIMITEDTIMEOFFERPROGRAM_BEGIN";
export const FETCH_LIMITEDTIMEOFFERPROGRAM_SUCCESS = "FETCH_LIMITEDTIMEOFFERPROGRAM_SUCCESS";
export const FETCH_LIMITEDTIMEOFFERPROGRAM_FAILURE = "FETCH_LIMITEDTIMEOFFERPROGRAM_FAILURE";

export const SET_ISDISCOUNTCARD = "SET_ISDISCOUNTCARD";
